export default "__VITE_PUBLIC_ASSET__41669c1f__"